import classNames from 'classnames';
import * as React from 'react';
import {prefix} from "../../wui-core/src/index";
import {SpaceCompactProps} from './iSpace'

const Compact: React.FC<SpaceCompactProps> = (props: SpaceCompactProps) => {
    const {
        direction,
        block,
        className,
        children,
        ...restProps
    } = props;

    const prefixCls = `${prefix}-space-compact`;
    const clx = classNames(
        prefixCls,
        {
            [`${prefixCls}-block`]: block,
            [`${prefixCls}-vertical`]: direction === 'vertical',
        },
        className,
    );

    const childNodes = React.Children.toArray(children);
    // =========================== Render ===========================
    if (childNodes.length === 0) {
        return null;
    }

    return (
        <div className={clx} {...restProps}>
            {childNodes}
        </div>
    );
};

export default Compact;
